module.exports = __webpack_public_path__ + "img/WX.26f20dfe.png";